























































































import Vue from 'vue';
import dayjs from 'dayjs';

export default Vue.extend({

  props: {
    tradingHours: {
      type: Object,
    }
  },
  methods: {
    formattedDate(date: Date) {
      return date && dayjs(date).format('HH:mm') || '';
    },
    onInputClick(id: string) {
      this.eventFire(document.getElementById(id), 'click');
    },
    eventFire(el: any, etype: any) {
      if (el.fireEvent) {
        el.fireEvent('on' + etype);
      } else {
        const evObj = document.createEvent('Events');
        evObj.initEvent(etype, true, false);
        el.dispatchEvent(evObj);
      }
    },
    translateDays(day: string) {
      switch (day) {
        case 'monday':
          return 'Segunda';
        case 'tuesday':
          return 'Terça';
        case 'wednesday':
          return 'Quarta';
        case 'thursday':
          return 'Quinta';
        case 'friday':
          return 'Sexta';
        case 'saturday':
          return 'Sabado';
        case 'sunday':
          return 'Domingo';
        default: 
          return day       
        
      }
    },


    
  },
});
